/**
 * @license Farris v0.0.2-8f3b649
 * (c) 2010-2018 Inspur, Inc.
 * License: MIT
 */
(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	typeof define === 'function' && define.amd ? define('@farris/farris-dom', ['exports'], factory) :
	(factory((global.farris = global.farris || {}, global.farris['farris-dom'] = {})));
}(this, (function (exports) { 'use strict';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

/**
 * @license Farris v0.0.2-8f3b649
 * (c) 2010-2018 Inspur, Inc.
 * License: MIT
 */
var Appearance = /** @class */ (function () {
    function Appearance(param) {
        var _this = this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return;
        }
        var keys = 'class,style';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
    }
    Appearance.prototype.toJSON = function () {
        return {
            "class": this.class,
            "style": this.style
        };
    };
    Appearance.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Appearance;
}());

var Border = /** @class */ (function () {
    function Border(param) {
        var _this = this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return;
        }
        var keys = 'left,top,right,bottom,color,width';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
    }
    Border.prototype.toJSON = function () {
        return {
            "left": this.left,
            "top": this.top,
            "right": this.right,
            "bottom": this.bottom,
            "all": this.all,
            "color": this.color,
            "width": this.width
        };
    };
    Border.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Border;
}());

var Font = /** @class */ (function () {
    function Font(param) {
        var _this = this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return;
        }
        var keys = 'family,size,color,bold,underscore,italic';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
    }
    Font.prototype.toJSON = function () {
        return {
            "family": this.family,
            "size": this.size,
            "color": this.color,
            "bold": this.bold,
            "underscore": this.underscore,
            "italic": this.italic
        };
    };
    Font.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Font;
}());

var Margin = /** @class */ (function () {
    function Margin(param) {
        var _this = this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return;
        }
        var keys = 'left,top,right,bottom,all,horizental,vertical';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
    }
    Margin.prototype.toJSON = function () {
        return {
            "left": this.left,
            "top": this.top,
            "right": this.right,
            "bottom": this.bottom,
            "all": this.all,
            "horizental": this.horizental,
            "vertical": this.vertical
        };
    };
    Margin.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Margin;
}());

var Padding = /** @class */ (function () {
    function Padding(param) {
        var _this = this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return;
        }
        var keys = 'left,top,right,bottom,all,horizental,vertical';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
    }
    Padding.prototype.toJSON = function () {
        return {
            "left": this.left,
            "top": this.top,
            "right": this.right,
            "bottom": this.bottom,
            "all": this.all,
            "horizental": this.horizental,
            "vertical": this.vertical
        };
    };
    Padding.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Padding;
}());

var Size = /** @class */ (function () {
    function Size(param) {
        var _this = this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return;
        }
        var keys = 'width,height';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
    }
    Size.prototype.toJSON = function () {
        return {
            "width": this.width,
            "height": this.height
        };
    };
    Size.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Size;
}());

var Component = /** @class */ (function () {
    function Component(param) {
        var _this = this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return;
        }
        var keys = 'id,visible,appearance,border,font,margin,padding,size';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                switch (key) {
                    case 'appearance':
                        _this[key] = new Appearance(obj[key]);
                        break;
                    case 'border':
                        _this[key] = new Border(obj[key]);
                        break;
                    case 'font':
                        _this[key] = new Font(obj[key]);
                        break;
                    case 'margin':
                        _this[key] = new Margin(obj[key]);
                        break;
                    case 'padding':
                        _this[key] = new Padding(obj[key]);
                        break;
                    case 'size':
                        _this[key] = new Size(obj[key]);
                        break;
                    default:
                        _this[key] = obj[key];
                        break;
                }
            }
        });
    }
    Component.prototype.toJSON = function () {
        var _this = this;
        var result = {
            "id": this.id,
            "type": "Component",
            "visible": this.visible,
            "appearance": null,
            "border": null,
            "font": null,
            "margin": null,
            "padding": null,
            "size": null,
        };
        var keys = 'appearance,border,font,margin,padding,size';
        keys.split(',').forEach(function (key) {
            if (_this[key]) {
                result[key] = _this[key].toJSON();
            }
        });
        return result;
    };
    Component.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Component;
}());

var ToolHelper = /** @class */ (function () {
    function ToolHelper() {
    }
    ToolHelper.createObjectByType = function (type) {
        var dom = Dom;
        // tslint:disable-next-line:no-eval
        return eval("dom." + type);
    };
    return ToolHelper;
}());

var CommandContainer = /** @class */ (function (_super) {
    __extends(CommandContainer, _super);
    function CommandContainer(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        _this.contents = [];
        var keys = 'contents';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                obj[key].forEach(function (item) {
                    var domObj = ToolHelper.createObjectByType(item.type);
                    if (domObj) {
                        _this.contents.push(new domObj(item));
                    }
                });
            }
        });
        return _this;
    }
    CommandContainer.prototype.toJSON = function () {
        var result = [];
        if (this.contents && this.contents.length) {
            this.contents.forEach(function (item) {
                result.push(item.toJSON());
            });
        }
        return Object.assign({}, _super.prototype.toJSON.call(this), { "contents": result, "type": "CommandContainer" });
    };
    CommandContainer.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return CommandContainer;
}(Component));

var ButtonGroup = /** @class */ (function (_super) {
    __extends(ButtonGroup, _super);
    function ButtonGroup(param) {
        return _super.call(this, param) || this;
    }
    ButtonGroup.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "ButtonGroup" });
    };
    ButtonGroup.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return ButtonGroup;
}(CommandContainer));

var Background = /** @class */ (function () {
    function Background(param) {
        var _this = this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return;
        }
        var keys = 'color';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
    }
    Background.prototype.toJSON = function () {
        return {
            "color": this.color
        };
    };
    Background.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Background;
}());

var Binding = /** @class */ (function () {
    function Binding(param) {
        var _this = this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return;
        }
        var keys = 'type,target,path';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
    }
    Binding.prototype.toJSON = function () {
        return {
            "type": this.type,
            "target": this.target,
            "path": this.path
        };
    };
    Binding.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Binding;
}());

var Command = /** @class */ (function (_super) {
    __extends(Command, _super);
    function Command(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        var keys = 'disable,icon,iconPosition,seperate,text,textAligment,click,template';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
        return _this;
    }
    Command.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), {
            "type": "Command",
            "disable": this.disable,
            "icon": this.icon,
            "iconPosition": this.iconPosition,
            "seperate": this.seperate,
            "text": this.text,
            "textAligment": this.textAligment,
            "click": this.click,
            "template": this.template
        });
    };
    Command.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Command;
}(Component));

var Button = /** @class */ (function (_super) {
    __extends(Button, _super);
    function Button(param) {
        return _super.call(this, param) || this;
    }
    Button.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "Button" });
    };
    Button.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Button;
}(Command));

var ContextMenu = /** @class */ (function (_super) {
    __extends(ContextMenu, _super);
    function ContextMenu(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        var keys = 'target,position';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
        return _this;
    }
    ContextMenu.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), {
            "type": "ContextMenu",
            "target": this.target,
            "position": this.position
        });
    };
    ContextMenu.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return ContextMenu;
}(CommandContainer));

var MenuItem = /** @class */ (function (_super) {
    __extends(MenuItem, _super);
    function MenuItem(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        _this.contents = [];
        var keys = 'contents';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                obj[key].forEach(function (item) {
                    var domObj = ToolHelper.createObjectByType(item.type);
                    if (domObj) {
                        _this.contents.push(new domObj(item));
                    }
                });
            }
        });
        return _this;
    }
    MenuItem.prototype.toJSON = function () {
        var result = [];
        if (this.contents && this.contents.length) {
            this.contents.forEach(function (item) {
                result.push(item.toJSON());
            });
        }
        return Object.assign({}, _super.prototype.toJSON.call(this), { "contents": result, "type": "MenuItem" });
    };
    MenuItem.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return MenuItem;
}(Command));

var Menu = /** @class */ (function (_super) {
    __extends(Menu, _super);
    function Menu(param) {
        return _super.call(this, param) || this;
    }
    Menu.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "Menu" });
    };
    Menu.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Menu;
}(CommandContainer));

var ToolBar = /** @class */ (function (_super) {
    __extends(ToolBar, _super);
    function ToolBar(param) {
        return _super.call(this, param) || this;
    }
    ToolBar.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "ToolBar" });
    };
    ToolBar.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return ToolBar;
}(CommandContainer));

var Container = /** @class */ (function (_super) {
    __extends(Container, _super);
    function Container(param) {
        return _super.call(this, param) || this;
    }
    Container.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "Container" });
    };
    Container.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Container;
}(Component));

var ContentContainer = /** @class */ (function (_super) {
    __extends(ContentContainer, _super);
    function ContentContainer(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        _this.contents = [];
        var keys = 'contents,contentTemplate,title,headerTemplate';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                if (key === 'contents') {
                    obj[key].forEach(function (item) {
                        var domObj = ToolHelper.createObjectByType(item.type);
                        if (domObj) {
                            _this.contents.push(new domObj(item));
                        }
                    });
                }
                else {
                    _this[key] = obj[key];
                }
            }
        });
        return _this;
    }
    ContentContainer.prototype.toJSON = function () {
        var result = [];
        if (this.contents && this.contents.length) {
            this.contents.forEach(function (item) {
                result.push(item.toJSON());
            });
        }
        return Object.assign({}, _super.prototype.toJSON.call(this), {
            "type": "ContentContainer",
            "contentTemplate": this.contentTemplate,
            "headerTemplate": this.headerTemplate,
            "title": this.title,
            "contents": result
        });
    };
    ContentContainer.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return ContentContainer;
}(Container));

var CollectionItem = /** @class */ (function (_super) {
    __extends(CollectionItem, _super);
    function CollectionItem(param) {
        return _super.call(this, param) || this;
    }
    CollectionItem.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "CollectionItem" });
    };
    CollectionItem.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return CollectionItem;
}(ContentContainer));

var ItemContainer = /** @class */ (function (_super) {
    __extends(ItemContainer, _super);
    function ItemContainer(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        _this.contents = [];
        var keys = 'contents';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                obj[key].forEach(function (item) {
                    var domObj = ToolHelper.createObjectByType(item.type);
                    if (domObj) {
                        _this.contents.push(new domObj(item));
                    }
                });
            }
        });
        return _this;
    }
    ItemContainer.prototype.toJSON = function () {
        var result = [];
        if (this.contents && this.contents.length) {
            this.contents.forEach(function (item) {
                result.push(item.toJSON());
            });
        }
        return Object.assign({}, _super.prototype.toJSON.call(this), { "contents": result, "type": "ItemContainer" });
    };
    ItemContainer.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return ItemContainer;
}(Container));

var Collepse = /** @class */ (function (_super) {
    __extends(Collepse, _super);
    function Collepse(param) {
        return _super.call(this, param) || this;
    }
    Collepse.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "Collepse" });
    };
    Collepse.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Collepse;
}(ItemContainer));

var FormGroup = /** @class */ (function (_super) {
    __extends(FormGroup, _super);
    function FormGroup(param) {
        return _super.call(this, param) || this;
    }
    FormGroup.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "FormGroup" });
    };
    FormGroup.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return FormGroup;
}(ItemContainer));

var Form = /** @class */ (function (_super) {
    __extends(Form, _super);
    function Form(param) {
        return _super.call(this, param) || this;
    }
    Form.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "Form" });
    };
    Form.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Form;
}(ItemContainer));

var Model = /** @class */ (function (_super) {
    __extends(Model, _super);
    function Model(param) {
        return _super.call(this, param) || this;
    }
    Model.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "Model" });
    };
    Model.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Model;
}(ContentContainer));

var Panel = /** @class */ (function (_super) {
    __extends(Panel, _super);
    function Panel(param) {
        return _super.call(this, param) || this;
    }
    Panel.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "Panel" });
    };
    Panel.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Panel;
}(ContentContainer));

var PlainContainer = /** @class */ (function (_super) {
    __extends(PlainContainer, _super);
    function PlainContainer(param) {
        return _super.call(this, param) || this;
    }
    PlainContainer.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "PlainContainer" });
    };
    PlainContainer.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return PlainContainer;
}(ContentContainer));

var Popover = /** @class */ (function (_super) {
    __extends(Popover, _super);
    function Popover(param) {
        return _super.call(this, param) || this;
    }
    Popover.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "Popover" });
    };
    Popover.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Popover;
}(ContentContainer));

var SlideVie = /** @class */ (function (_super) {
    __extends(SlideVie, _super);
    function SlideVie(param) {
        return _super.call(this, param) || this;
    }
    SlideVie.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "SlideVie" });
    };
    SlideVie.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return SlideVie;
}(ItemContainer));

var TabPage = /** @class */ (function (_super) {
    __extends(TabPage, _super);
    function TabPage(param) {
        return _super.call(this, param) || this;
    }
    TabPage.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "TabPage" });
    };
    TabPage.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return TabPage;
}(ContentContainer));

var Tab = /** @class */ (function (_super) {
    __extends(Tab, _super);
    function Tab(param) {
        return _super.call(this, param) || this;
    }
    Tab.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "Tab" });
    };
    Tab.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Tab;
}(ItemContainer));

var Data = /** @class */ (function (_super) {
    __extends(Data, _super);
    function Data(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        var keys = 'binding';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = new Binding(obj[key]);
            }
        });
        return _this;
    }
    Data.prototype.toJSON = function () {
        var result = { "binding": null, "type": "Data" };
        if (this.binding) {
            result["binding"] = this.binding.toJSON();
        }
        return Object.assign({}, _super.prototype.toJSON.call(this), result);
    };
    Data.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Data;
}(Component));

var Paginition = /** @class */ (function () {
    function Paginition(param) {
        var _this = this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return;
        }
        var keys = 'pageSize,pageNumber';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
    }
    Paginition.prototype.toJSON = function () {
        return {
            "type": "Paginition",
            "pageSize": this.pageSize,
            "pageNumber": this.pageNumber
        };
    };
    Paginition.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Paginition;
}());
var SummaryItem = /** @class */ (function () {
    function SummaryItem(param) {
        var _this = this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return;
        }
        var keys = 'summaryType,aggregationType,name,column,align,format,customizeText,showInGroupFooter,skipEmptyValues';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
    }
    SummaryItem.prototype.toJSON = function () {
        return {
            "summaryType": this.summaryType,
            "aggregationType": this.aggregationType,
            "name": this.summaryType,
            "column": this.summaryType,
            "align": this.summaryType,
            "format": this.summaryType,
            "customizeText": this.customizeText,
            "showInGroupFooter": this.showInGroupFooter,
            "skipEmptyValues": this.skipEmptyValues,
        };
    };
    SummaryItem.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return SummaryItem;
}());
var Summary = /** @class */ (function () {
    function Summary(param) {
        var _this = this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return;
        }
        this.items = [];
        var keys = 'items';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                obj[key].forEach(function (item) {
                    _this.items.push(new SummaryItem(item));
                });
            }
        });
    }
    Summary.prototype.toJSON = function () {
        var itemArray = [];
        if (this.items && this.items.length) {
            this.items.forEach(function (item) {
                itemArray.push(item.toJSON());
            });
        }
        return Object.assign({}, {
            "items": itemArray
        });
    };
    Summary.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Summary;
}());
var DataCollection = /** @class */ (function (_super) {
    __extends(DataCollection, _super);
    function DataCollection(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        _this.fields = [];
        var keys = "dataSource,fields,focusedItem,focusedIndex,pagination,identifyField,multiSelect\n    ,selectable,itemTemplate,toolBar,sortable,sort,summary";
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                switch (key) {
                    case 'fields':
                        obj[key].forEach(function (item) {
                            var domObj = ToolHelper.createObjectByType(item.type);
                            if (domObj) {
                                _this.fields.push(new domObj(item));
                            }
                        });
                        break;
                    case 'pagination':
                        _this[key] = new Paginition(obj[key]);
                        break;
                    case 'toolBar':
                        _this[key] = new ToolBar(obj[key]);
                        break;
                    case 'summary':
                        _this[key] = new Summary(obj[key]);
                        break;
                    default:
                        _this[key] = obj[key];
                        break;
                }
            }
        });
        return _this;
    }
    DataCollection.prototype.toJSON = function () {
        var _this = this;
        var fieldArray = [];
        if (this.fields && this.fields.length) {
            this.fields.forEach(function (f) {
                fieldArray.push(f.toJSON());
            });
        }
        var result = {
            "type": "DataCollection",
            "dataSource": this.dataSource,
            "fields": fieldArray,
            "focusedItem": this.focusedItem,
            "focusedIndex": this.focusedIndex,
            "pagination": null,
            "identifyField": this.identifyField,
            "multiSelect": this.multiSelect,
            "selectable": this.selectable,
            "itemTemplate": this.itemTemplate,
            "toolBar": null,
            "sortable": this.sortable,
            "sort": this.sort,
            "summary": null
        };
        var keys = 'pagination,toolBar,summary';
        keys.split(',').forEach(function (key) {
            if (_this[key]) {
                result[key] = _this[key].toJSON();
            }
        });
        return Object.assign({}, _super.prototype.toJSON.call(this), result);
    };
    DataCollection.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return DataCollection;
}(Data));

var Flat = /** @class */ (function (_super) {
    __extends(Flat, _super);
    function Flat(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        var keys = 'groupable,group';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
        return _this;
    }
    Flat.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), {
            "type": "Flat",
            "groupable": this.groupable,
            "group": this.group,
        });
    };
    Flat.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Flat;
}(DataCollection));

var DataGrid = /** @class */ (function (_super) {
    __extends(DataGrid, _super);
    function DataGrid(param) {
        return _super.call(this, param) || this;
    }
    DataGrid.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "DataGrid" });
    };
    DataGrid.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return DataGrid;
}(Flat));

var ListView = /** @class */ (function (_super) {
    __extends(ListView, _super);
    function ListView(param) {
        return _super.call(this, param) || this;
    }
    ListView.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "ListView" });
    };
    ListView.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return ListView;
}(Flat));

var HierarchyOption = /** @class */ (function () {
    function HierarchyOption(param) {
        var _this = this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        var keys = 'gradingRules,gradingCode,codingRules,mainField,parentField';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
    }
    HierarchyOption.prototype.toJSON = function () {
        return Object.assign({}, {
            "gradingRules": this.gradingRules,
            "gradingCode": this.gradingCode,
            "codingRules": this.codingRules,
            "mainField": this.mainField,
            "parentField": this.parentField,
        });
    };
    HierarchyOption.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return HierarchyOption;
}());
var Hierarchy = /** @class */ (function (_super) {
    __extends(Hierarchy, _super);
    function Hierarchy(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        var keys = 'hierarchyOption,expendAll,expendLevel,recursive';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                if (key === 'hierarchyOption') {
                    _this[key] = new HierarchyOption(obj[key]);
                }
                else {
                    _this[key] = obj[key];
                }
            }
        });
        return _this;
    }
    Hierarchy.prototype.toJSON = function () {
        var result = {
            "type": "Hierarchy",
            "hierarchyOption": null,
            "expendAll": this.expendAll,
            "expendLevel": this.expendLevel,
            "recursive": this.recursive
        };
        if (this.hierarchyOption) {
            result["hierarchyOption"] = this.hierarchyOption.toJSON();
        }
        return Object.assign({}, _super.prototype.toJSON.call(this), result);
    };
    Hierarchy.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Hierarchy;
}(DataCollection));

var TreeGrid = /** @class */ (function (_super) {
    __extends(TreeGrid, _super);
    function TreeGrid(param) {
        return _super.call(this, param) || this;
    }
    TreeGrid.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "TreeGrid" });
    };
    TreeGrid.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return TreeGrid;
}(Hierarchy));

var TreeView = /** @class */ (function (_super) {
    __extends(TreeView, _super);
    function TreeView(param) {
        return _super.call(this, param) || this;
    }
    TreeView.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "TreeView" });
    };
    TreeView.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return TreeView;
}(Hierarchy));

var CollectionField = /** @class */ (function (_super) {
    __extends(CollectionField, _super);
    function CollectionField(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        var keys = 'dataField,displayTemplate';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
        return _this;
    }
    CollectionField.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), {
            "type": "CollectionField",
            "dataField": this.dataField,
            "displayTemplate": this.displayTemplate
        });
    };
    CollectionField.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return CollectionField;
}(Data));

var FormField = /** @class */ (function (_super) {
    __extends(FormField, _super);
    function FormField(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        var keys = 'title';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
        return _this;
    }
    FormField.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "title": this.title, "type": "FormField" });
    };
    FormField.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return FormField;
}(Data));

var EditableField = /** @class */ (function (_super) {
    __extends(EditableField, _super);
    function EditableField(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        var keys = 'readonly,require,disable';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
        return _this;
    }
    EditableField.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), {
            "type": "EditableField",
            "readonly": this.readonly,
            "require": this.require,
            "disable": this.disable
        });
    };
    EditableField.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return EditableField;
}(FormField));

var GridField = /** @class */ (function (_super) {
    __extends(GridField, _super);
    function GridField(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        var keys = 'caption,captionTemplate,editor,readonly,require,draggable,frozen,sortable,sortOrder,resizeable';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                if (key === 'editor') {
                    _this[key] = new EditableField(obj[key]);
                }
                else {
                    _this[key] = obj[key];
                }
            }
        });
        return _this;
    }
    GridField.prototype.toJSON = function () {
        var result = {
            "type": "GridField",
            "caption": this.caption,
            "captionTemplate": this.captionTemplate,
            "editor": null,
            "readonly": this.readonly,
            "require": this.require,
            "draggable": this.draggable,
            "frozen": this.frozen,
            "sortable": this.sortable,
            "sortOrder": this.sortOrder,
            "resizeable": this.resizeable
        };
        if (this.editor) {
            result["editor"] = this.editor.toJSON();
        }
        return Object.assign({}, _super.prototype.toJSON.call(this), result);
    };
    GridField.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return GridField;
}(CollectionField));

var ViewField = /** @class */ (function (_super) {
    __extends(ViewField, _super);
    function ViewField(param) {
        return _super.call(this, param) || this;
    }
    ViewField.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "ViewField" });
    };
    ViewField.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return ViewField;
}(CollectionField));

var DisplayField = /** @class */ (function (_super) {
    __extends(DisplayField, _super);
    function DisplayField(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        var keys = 'displayTemplate';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
        return _this;
    }
    DisplayField.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "displayTemplate": this.displayTemplate, "type": "DisplayField" });
    };
    DisplayField.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return DisplayField;
}(FormField));

var SwitchField = /** @class */ (function (_super) {
    __extends(SwitchField, _super);
    function SwitchField(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        var keys = 'checked';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
        return _this;
    }
    SwitchField.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "SwitchField", "checked": this.checked });
    };
    SwitchField.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return SwitchField;
}(EditableField));

var CheckBox = /** @class */ (function (_super) {
    __extends(CheckBox, _super);
    function CheckBox(param) {
        return _super.call(this, param) || this;
    }
    CheckBox.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "CheckBox" });
    };
    CheckBox.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return CheckBox;
}(SwitchField));

var CollectionSwitch = /** @class */ (function (_super) {
    __extends(CollectionSwitch, _super);
    function CollectionSwitch(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        _this.contents = [];
        var keys = 'contents';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                obj[key].forEach(function (item) {
                    var domObj = ToolHelper.createObjectByType(item.type);
                    if (domObj) {
                        _this.contents.push(new domObj(item));
                    }
                });
            }
        });
        return _this;
    }
    CollectionSwitch.prototype.toJSON = function () {
        var result = [];
        if (this.contents && this.contents.length) {
            this.contents.forEach(function (item) {
                result.push(item.toJSON());
            });
        }
        return Object.assign({}, _super.prototype.toJSON.call(this), {
            "type": "CollectionSwitch",
            "contents": result
        });
    };
    CollectionSwitch.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return CollectionSwitch;
}(SwitchField));

var CheckGroup = /** @class */ (function (_super) {
    __extends(CheckGroup, _super);
    function CheckGroup(param) {
        return _super.call(this, param) || this;
    }
    CheckGroup.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "CheckGroup" });
    };
    CheckGroup.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return CheckGroup;
}(CollectionSwitch));

var RadioGroup = /** @class */ (function (_super) {
    __extends(RadioGroup, _super);
    function RadioGroup(param) {
        return _super.call(this, param) || this;
    }
    RadioGroup.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "RadioGroup" });
    };
    RadioGroup.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return RadioGroup;
}(CollectionSwitch));

var InputField = /** @class */ (function (_super) {
    __extends(InputField, _super);
    function InputField(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        var keys = 'placeHolder,format,validation,defaultValue,value';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
        return _this;
    }
    InputField.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), {
            "type": "InputField",
            "placeHolder": this.placeHolder,
            "format": this.format,
            "validation": this.validation,
            "defaultValue": this.defaultValue,
            "value": this.value
        });
    };
    InputField.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return InputField;
}(EditableField));

var ValueField = /** @class */ (function (_super) {
    __extends(ValueField, _super);
    function ValueField(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        var keys = 'maxValue,minValue';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
        return _this;
    }
    ValueField.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), {
            "type": "ValueField",
            "maxValue": this.maxValue,
            "minValue": this.minValue
        });
    };
    ValueField.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return ValueField;
}(InputField));

var DateBox = /** @class */ (function (_super) {
    __extends(DateBox, _super);
    function DateBox(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        var keys = 'parseFormats';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
        return _this;
    }
    DateBox.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), {
            "type": "DateBox",
            "parseFormats": this.parseFormats
        });
    };
    DateBox.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return DateBox;
}(ValueField));

var NumericBox = /** @class */ (function (_super) {
    __extends(NumericBox, _super);
    function NumericBox(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        var keys = 'spin,step';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
        return _this;
    }
    NumericBox.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), {
            "type": "NumericBox",
            "spin": this.spin,
            "step": this.step
        });
    };
    NumericBox.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return NumericBox;
}(ValueField));

var TimeBox = /** @class */ (function (_super) {
    __extends(TimeBox, _super);
    function TimeBox(param) {
        return _super.call(this, param) || this;
    }
    TimeBox.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "TimeBox" });
    };
    TimeBox.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return TimeBox;
}(ValueField));

var TextField = /** @class */ (function (_super) {
    __extends(TextField, _super);
    function TextField(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        var keys = 'maxLength';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
        return _this;
    }
    TextField.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), {
            "type": "TextField",
            "maxLength": this.maxLength
        });
    };
    TextField.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return TextField;
}(InputField));

var MultiTextBox = /** @class */ (function (_super) {
    __extends(MultiTextBox, _super);
    function MultiTextBox(param) {
        return _super.call(this, param) || this;
    }
    MultiTextBox.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "MultiTextBox" });
    };
    MultiTextBox.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return MultiTextBox;
}(TextField));

var TextBox = /** @class */ (function (_super) {
    __extends(TextBox, _super);
    function TextBox(param) {
        return _super.call(this, param) || this;
    }
    TextBox.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "TextBox" });
    };
    TextBox.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return TextBox;
}(TextField));

var ReferenceField = /** @class */ (function (_super) {
    __extends(ReferenceField, _super);
    function ReferenceField(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        var keys = 'dataSource';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
        return _this;
    }
    ReferenceField.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), {
            "type": "ReferenceField",
            "dataSource": this.dataSource
        });
    };
    ReferenceField.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return ReferenceField;
}(InputField));

var LookupEdit = /** @class */ (function (_super) {
    __extends(LookupEdit, _super);
    function LookupEdit(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        var keys = 'mulitSelect';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
        return _this;
    }
    LookupEdit.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), {
            "type": "LookupEdit",
            "mulitSelect": this.mulitSelect
        });
    };
    LookupEdit.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return LookupEdit;
}(ReferenceField));

var Select = /** @class */ (function (_super) {
    __extends(Select, _super);
    function Select(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        var keys = 'mulitSelect';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
        return _this;
    }
    Select.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), {
            "type": "Select",
            "mulitSelect": this.mulitSelect
        });
    };
    Select.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Select;
}(ReferenceField));

// export * from './chart/chart';

// export * from './utility';


var Dom = Object.freeze({
	ButtonGroup: ButtonGroup,
	Button: Button,
	CommandContainer: CommandContainer,
	Command: Command,
	ContextMenu: ContextMenu,
	MenuItem: MenuItem,
	Menu: Menu,
	ToolBar: ToolBar,
	Appearance: Appearance,
	Background: Background,
	Binding: Binding,
	Border: Border,
	Component: Component,
	Font: Font,
	Margin: Margin,
	Padding: Padding,
	Size: Size,
	CollectionItem: CollectionItem,
	Collepse: Collepse,
	Container: Container,
	ContentContainer: ContentContainer,
	FormGroup: FormGroup,
	Form: Form,
	ItemContainer: ItemContainer,
	Model: Model,
	Panel: Panel,
	PlainContainer: PlainContainer,
	Popover: Popover,
	SlideVie: SlideVie,
	TabPage: TabPage,
	Tab: Tab,
	DataGrid: DataGrid,
	Flat: Flat,
	ListView: ListView,
	HierarchyOption: HierarchyOption,
	Hierarchy: Hierarchy,
	TreeGrid: TreeGrid,
	TreeView: TreeView,
	Paginition: Paginition,
	SummaryItem: SummaryItem,
	Summary: Summary,
	DataCollection: DataCollection,
	CollectionField: CollectionField,
	GridField: GridField,
	ViewField: ViewField,
	DisplayField: DisplayField,
	CheckBox: CheckBox,
	CheckGroup: CheckGroup,
	CollectionSwitch: CollectionSwitch,
	RadioGroup: RadioGroup,
	SwitchField: SwitchField,
	DateBox: DateBox,
	NumericBox: NumericBox,
	TimeBox: TimeBox,
	ValueField: ValueField,
	MultiTextBox: MultiTextBox,
	TextBox: TextBox,
	TextField: TextField,
	LookupEdit: LookupEdit,
	ReferenceField: ReferenceField,
	Select: Select,
	InputField: InputField,
	FormField: FormField,
	EditableField: EditableField,
	Data: Data
});

exports.ButtonGroup = ButtonGroup;
exports.Button = Button;
exports.CommandContainer = CommandContainer;
exports.Command = Command;
exports.ContextMenu = ContextMenu;
exports.MenuItem = MenuItem;
exports.Menu = Menu;
exports.ToolBar = ToolBar;
exports.Appearance = Appearance;
exports.Background = Background;
exports.Binding = Binding;
exports.Border = Border;
exports.Component = Component;
exports.Font = Font;
exports.Margin = Margin;
exports.Padding = Padding;
exports.Size = Size;
exports.CollectionItem = CollectionItem;
exports.Collepse = Collepse;
exports.Container = Container;
exports.ContentContainer = ContentContainer;
exports.FormGroup = FormGroup;
exports.Form = Form;
exports.ItemContainer = ItemContainer;
exports.Model = Model;
exports.Panel = Panel;
exports.PlainContainer = PlainContainer;
exports.Popover = Popover;
exports.SlideVie = SlideVie;
exports.TabPage = TabPage;
exports.Tab = Tab;
exports.DataGrid = DataGrid;
exports.Flat = Flat;
exports.ListView = ListView;
exports.HierarchyOption = HierarchyOption;
exports.Hierarchy = Hierarchy;
exports.TreeGrid = TreeGrid;
exports.TreeView = TreeView;
exports.Paginition = Paginition;
exports.SummaryItem = SummaryItem;
exports.Summary = Summary;
exports.DataCollection = DataCollection;
exports.CollectionField = CollectionField;
exports.GridField = GridField;
exports.ViewField = ViewField;
exports.DisplayField = DisplayField;
exports.CheckBox = CheckBox;
exports.CheckGroup = CheckGroup;
exports.CollectionSwitch = CollectionSwitch;
exports.RadioGroup = RadioGroup;
exports.SwitchField = SwitchField;
exports.DateBox = DateBox;
exports.NumericBox = NumericBox;
exports.TimeBox = TimeBox;
exports.ValueField = ValueField;
exports.MultiTextBox = MultiTextBox;
exports.TextBox = TextBox;
exports.TextField = TextField;
exports.LookupEdit = LookupEdit;
exports.ReferenceField = ReferenceField;
exports.Select = Select;
exports.InputField = InputField;
exports.FormField = FormField;
exports.EditableField = EditableField;
exports.Data = Data;

Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=farris-dom.umd.js.map
